import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import DrawerMenu from "./DrawerMenu";
import logo from "../../assets/images/logo.png";

function Navbar() {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const toggleDrawer = () => {
        setIsDrawerOpen((prev) => !prev);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    return (
        <>
            <header className="navbar">
                <div className="navbar-container">
                    <Link to="/" className="navbar-logo">
                        <img src={logo} alt="Cris Gym" />
                    </Link>

                    <nav className="navbar-links">
                        <NavLink to="/" className="nav-link">
                            Acasa
                        </NavLink>
                        <NavLink to="/despre" className="nav-link">
                            Despre
                        </NavLink>
                        <NavLink to="/antrenori" className="nav-link">
                            Antrenori
                        </NavLink>
                        <NavLink to="/abonamente" className="nav-link">
                            Abonamente
                        </NavLink>
                        <NavLink to="/galerie" className="nav-link">
                            Galerie
                        </NavLink>
                        <NavLink to="/contact" className="nav-link">
                            Contact
                        </NavLink>
                    </nav>

                    <div className="navbar-actions">
                        <Link to="/contact" className="navbar-cta">
                            Inscrie-te
                        </Link>

                        <button className="menu-toggle" onClick={toggleDrawer}>
                            ☰
                        </button>
                    </div>
                </div>
            </header>

            <DrawerMenu isOpen={isDrawerOpen} onClose={closeDrawer} />
        </>
    );
}

export default Navbar;